import { Globe2, PenTool, Settings2 } from "lucide-react";
import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

const icons = [PenTool, Settings2, Globe2];

export function TrinityModel({ positioning, operatingModel, media = [] }) {
  return (
    <section id="trinity-model" className="section trinity-model-section" data-slide="03" data-testid="trinity-model-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="trinity-model-overline">{operatingModel.overline}</p>
        <h2 data-testid="trinity-model-title">{operatingModel.title}</h2>
        <p data-testid="trinity-model-description">{operatingModel.description}</p>
      </div>

      <div className="model-proof-grid" data-testid="trinity-model-grid">
        {operatingModel.cards.map((card, index) => {
          const Icon = icons[index];
          return (
            <article className="operating-card" key={card.title} data-testid={`trinity-model-card-${index + 1}`}>
              <CardMediaSlot image={media[index]?.image} label={card.title} testId={`trinity-model-media-${index + 1}`} className="compact-media" />
              <div className="solution-icon" data-testid={`trinity-model-icon-${index + 1}`}>
                <Icon size={24} aria-hidden="true" />
              </div>
              <h3 data-testid={`trinity-model-card-title-${index + 1}`}>{card.title}</h3>
              <p data-testid={`trinity-model-card-text-${index + 1}`}>{card.text}</p>
              <ul data-testid={`trinity-model-card-list-${index + 1}`}>
                {card.items.map((item) => (
                  <li key={item} data-testid={`trinity-model-card-item-${index + 1}-${item.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>{item}</li>
                ))}
              </ul>
            </article>
          );
        })}
      </div>

      <div className="positioning-strip" data-testid="positioning-summary-strip">
        {positioning.cards.map(([title, text], index) => (
          <div key={title} data-testid={`positioning-summary-${index + 1}`}>
            <strong>{title}</strong>
            <span>{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}